import { useQuery } from "@tanstack/react-query";
import { Button } from "../../../components/ui/Button";
import { Spinner } from "../../../components/ui/misc";
import { api } from "../../../lib/api/endpoints";
import { formatDateTime } from "../../../lib/format";
import { qk } from "../../../lib/queries";

export function VersionsPanel({
  themeId,
  viewing,
  onView,
}: {
  themeId: string;
  viewing: string | null;
  onView: (id: string | null) => void;
}) {
  const { data, isLoading } = useQuery({
    queryKey: qk.themeVersions(themeId),
    queryFn: () => api.themes.versions(themeId),
  });
  if (isLoading) return <Spinner label="Loading versions…" />;
  return (
    <ul className="grid gap-2">
      {(data ?? [])
        .filter((v) => v.status === "published")
        .map((v) => (
          <li
            key={v.id}
            className="flex items-center gap-3 rounded-lg border border-line bg-surface px-4 py-2.5 text-sm"
          >
            <span className="font-medium">Version {v.version}</span>
            <span className="flex-1 text-ink-3">
              published {v.publishedAt ? formatDateTime(v.publishedAt) : "?"}
              {v.createdBy ? ` by ${v.createdBy.name}` : ""}
            </span>
            <Button
              size="sm"
              aria-pressed={viewing === v.id}
              aria-label={`View version ${v.version}`}
              onClick={() => onView(viewing === v.id ? null : v.id)}
            >
              View
            </Button>
          </li>
        ))}
    </ul>
  );
}
